import { Button, Tooltip } from '@next-nx/shared-ui/atoms'
import { useFindMenu, useTealium } from '@next-nx/hooks'
import React from 'react'
import { getIcon } from '@next-nx/utils/icons'
import { MenuItemType } from '@next-nx/utils/types'
import styles from './LandingServiziSection.module.sass'
import { Info } from '@next-nx/shared-ui/icons'
import { getTimestamp } from '@next-nx/utils'


interface Props {
  item?: MenuItemType | undefined
  onClick: () => void
  className?: string
  variant?: 'modal' | 'in_pagina'
}

const LandingServiziSection = (props: Props) => {

  const { 
    item = undefined,
    onClick = undefined,
    className = '',
    variant = 'modal'
  } = props

  const list = useFindMenu("list", item)
  const preventivo = useFindMenu("preventivo", item)
  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()
  
    linkDataLayer({
       virtual: "action",
       action_name: "richiesta_preventivo", 
       action_tech: "click",
       action_type: "richiedi_preventivo",
       action_timestamp,
       action_effect: "form_richiesta_preventivo_accesso"
    });
  }

  return item ? (
    <div className={`${styles.landingServiziSection} ${className}`}>
      <p className={styles.title}>{item.name}</p>
      <div className={styles.content}>
        {list?.children && list.children?.edges.length > 0 && (
        <div className={`${styles.list} ${styles[`list--${variant}`]}`}>
          {list.children?.edges.map(x => (
            <div className={styles.item} key={x.node.pk}>
              <span className={styles.itemIcon}>
                {getIcon(x.node.style)}
              </span>
              <span className={styles.itemLabel}>
                {x.node.name}
                {!!x.node.description &&
                <Tooltip 
                  id={`tooltip-servizio-${x.node.pk}`}
                  label={x.node.description}
                  pos="top"
                >
                  <span className={styles.itemInfo}><Info /></span>
                </Tooltip>
                }
              </span> 
            </div>
          ))}
        </div>
        )}
        {preventivo && (variant==='modal') && (
        <div className={styles.boxTesto}>
          <p className={styles.boxTestoTitle}>{preventivo.name}</p>
          <div className={styles.boxTestoCtaBox}>
            <Button label={preventivo.ctaLabel} onClick={() => {
              onClick && onClick()
              handleTracking()
              }} />
          </div>
        </div>
        )}
      </div>
    </div>
  ) : <></>
}

export default LandingServiziSection
